import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { DashboardService } from '../../services/dashboard.service';

import { DashboardBankAccount } from '../../interfaces/dashboard.interface';
import { TableColumn } from '../../interfaces/table-config.interface';
  




@Component({
    selector: 'app-mi-perfil',
    standalone: true,
    imports: [ReactiveFormsModule],
    templateUrl: 'mi-perfil.component.html',
    styleUrls: ['mi-perfil.component.css']
})


export class MiPerfilComponent implements OnInit {

    
    bankAccountsTableColumns: TableColumn[] = [
        { key: 'bankName',         label: 'Banco', sortable: true },
        { key: 'accountType',          label: 'Tipo de cuenta', sortable: true },
        { key: 'accountNumber',  label: 'Número de cuenta', sortable: true },
        { key: 'currencyName',        label: 'Moneda', sortable: true },
      ];
    
    authService = inject(AuthService);
    dashboardService = inject(DashboardService);
    bankAccounts = this.dashboardService.bankAccounts;
    bankAccountsData: DashboardBankAccount[] = [];

    perfilForm: FormGroup = new FormGroup({
        email: new FormControl({ value: '', disabled: true }),
        telefonoCasa: new FormControl({ value: '', disabled: true }),
        telefonoCelular: new FormControl({ value: '', disabled: true }),
    });


    ngOnInit() {
        this.perfilData();
        this.loadBankAccounts();
    }

    perfilData() {
        const datos = this.authService.saveDataPerfil();

        if (datos && Array.isArray(datos)) {
            const [email, telefonoCasa, telefonoCelular] = datos;

            const formValues = {
                email: email || '',
                telefonoCasa: telefonoCasa || '',
                telefonoCelular: telefonoCelular || '',
            };

            this.perfilForm.patchValue(formValues);
        } else {
            console.error('No se pudieron obtener los datos del perfil');
        }
    }


    /**Load bank accounts from dashboard service */
    loadBankAccounts() {
        const bankAccounts = this.dashboardService.bankAccounts();
        if (bankAccounts.length > 0) return;

        this.dashboardService.getDashboardData().subscribe({
          next: () => this.bankAccountsData = bankAccounts || [],
          error: () => this.bankAccountsData = []
        });
      }
}